export default class ColorConverterService {
  convertArtifactTypeColorToCssColor(artifactTypeColor: string, itemName: string): string {
    if (!artifactTypeColor) return this.randomColor(itemName)
    const rgb = artifactTypeColor.split(':')
    if (rgb.length === 3) {
      return `rgb(${rgb[0]},${rgb[1]},${rgb[2]})`
    } else {
      return this.randomColor(itemName)
    }
  }

  randomColor(itemName: string) {
    // Use the item's name as a key to store its color
    let color = localStorage.getItem(itemName)
    if (!color) {
      color =
        'rgb(' +
        Math.round(Math.random() * 255) +
        ',' +
        Math.round(Math.random() * 255) +
        ',' +
        Math.round(Math.random() * 255) +
        ')'
      localStorage.setItem(itemName, color)
    }
    return color
  }
}
